import { Draft } from '@reduxjs/toolkit';

import { ICategoryData } from '../../index';

function createSuccess(draft: Draft<ICategoryData>) {
  draft.create.config.isLoading = false;
}

export default createSuccess;
